import { endOfDecade, fromUnixTime, sub } from "date-fns";
import format from "date-fns/format";

import { TBlueAny, TBlueTable } from "@app/types/insider";
import {
  ICustomExchangeRate,
  IExchangeRate,
} from "@app/types/insider/currency";

import { epBuilderAnyIssuer } from "../routines/mapperfn-pathbuilder";

const exchangeRateMapper = (item_: IExchangeRate | string) => {
  const env = process.env.REACT_APP_MODE;
  const item = (
    env === "DELPHI" ? item_ : JSON.parse(item_ as string)
  ) as IExchangeRate;

  try {
    if (env !== "DELPHI") {
      item.XRDATESTRING = format(
        new Date(fromUnixTime(item.XRDATEUNIX)),
        "yyyy-MM-dd"
      );
    }
    return item;
  } catch (error) {
    return null;
  }
};

export const currencyRates: TBlueTable<IExchangeRate> = {
  name: "currencyRates",
  empty: {} as IExchangeRate,
  initialState: {},
  primaryKey: "XRDATESTRING",
  pkeyUrl: "/select/loadexrate_pkey",
  apiUrl: "/select/loadexrate_range",
  mapWrite: exchangeRateMapper,
  mapRead: (data) => data,
  starfx: true,
  idb: true,
  starfx_index: "XRDATESTRING",
  idb_indexes: [
    // { name: 'byHash', keyPath: ['_hkey', '_hvalue'] },
    { name: "byDate", keyPath: "XRDATESTRING" },
    // { name: 'shid0', keyPath: 'shid0' },
  ],
  urlPathBuilder: epBuilderAnyIssuer,
  bootPriority: 2,
  onmru: "new",
  oncsdb: "full",
  label: "Curs valutar",
  appContext: ["CtxPersonalKarma", "CtxJurnalCorporate"],
};

export const currencyRatesCustom: TBlueTable<IExchangeRate> = {
  name: "currencyRatesCustom",
  empty: {} as IExchangeRate,
  initialState: {},
  primaryKey: "XRDATESTRING",
  pkeyUrl: null,
  apiUrl: null,
  mapWrite: exchangeRateMapper,
  mapRead: (data) => data,
  starfx: true,
  idb: true,
  starfx_index: "XRDATESTRING",
  urlPathBuilder: epBuilderAnyIssuer,
  idb_indexes: [
    // { name: 'byHash', keyPath: ['_hkey', '_hvalue'] },
    { name: "byDate", keyPath: "XRDATESTRING" },
    // { name: 'shid0', keyPath: 'shid0' },
  ],
  bootPriority: 1,
  onmru: "new",
  oncsdb: "full",
  label: "Curs valutar",
  appContext: ["CtxPersonalKarma"],
};

export const currencies: TBlueAny = {
  name: "currencies",
  initialState: ["EUR", "RON", "USD"],
  apiUrl: "/assets/monede",
  isblueany: true,
  starfx: true,
  idb: true,
  bootPriority: 2,
  onmru: "ifempty",
  oncsdb: "no",
};
